var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "complete_content" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [_c("dd-menu", { ref: "menuRef" }), _vm._v(" "), _vm._m(0)],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "title" }, [_c("h2", [_vm._v("仮登録完了")])]),
      _vm._v(" "),
      _c("div", { staticClass: "user_regist_thanks" }, [
        _c("p", [
          _vm._v("\n            仮登録いただきありがとうございます。"),
          _c("br"),
          _vm._v(
            "\n            ご入力いただいたアカウントはまだ本登録が完了しておりません。"
          ),
          _c("br"),
          _vm._v(
            "\n            引き続き、ご案内メールより本登録を行ってください。\n          "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n            ※受信制限をされている方は、「"),
          _c("span", { staticClass: "pickup" }, [_vm._v("@domans.co.jp")]),
          _vm._v("」からのメールを受信許可に設定してください"),
          _c("br"),
          _vm._v(
            "\n            ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。\n          "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-856186d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-856186d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcSendMailComplete.vue
// module id = null
// module chunks = 